import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Offline, Online } from 'react-detect-offline';
import './App.css';
// Reducers
import ContainerChecklistsView from './containers/ContainerChecklistsView';
import ContainerSingleChecklistView from './containers/ContainerSingleChecklistView';

const App = () => {
	return (
        <div>
            <Online>
                <BrowserRouter>
                        <Switch>
                            <Route path="/lists" component={ContainerChecklistsView} />
                            <Route path="/list/:id" component={ContainerSingleChecklistView} />
                            <Route exact path="/" component={ContainerChecklistsView} />
                            <Route component={ContainerChecklistsView}/>
                        </Switch>
                </BrowserRouter>
            </Online>
            <Offline>
                <span>Sorry, you are offline</span>
            </Offline>
        </div>
    )
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js